import React from 'react';
import useOrganizationClientRecordBillingDetails from '../../../../../../hooks/api/useOrganizationClientRecordBillingDetails';
import { AnimateLoadedContent } from '../../../../../v2BaseComponents/Loader';
import { Form } from '../../../../../v2BaseComponents/Form';
import EditClientBillingInfoFields, {
    FormValue,
    formValueToCreateClientRecordInvitationRequest,
    getDefaultFormValue,
} from '../../../../../shared/EditClientBillingInfo/EditClientBillingInfoFields';

export type EditClientRecordBillingContactDetailsOwnProps = {
    clientRecordId: string;
    onCancel: () => void;
    onSave: () => void;
};

export type EditClientRecordBillingContactDetailsProps = EditClientRecordBillingContactDetailsOwnProps;

const emptyBillingDetails: FormValue = {
    name: '',
    email: '',
    phoneNumber: '',
};

const EditClientRecordBillingContactDetails: React.FC<EditClientRecordBillingContactDetailsProps> = ({
    clientRecordId,
    onCancel,
    onSave,
}) => {
    const { isLoadingBillingDetails, isUpdatingBillingDetails, updateBillingDetails, billingDetails } =
        useOrganizationClientRecordBillingDetails({
            organizationClientRecordId: clientRecordId,
            onUpdatedBillingDetails: onSave,
        });

    return (
        <AnimateLoadedContent isLoading={isLoadingBillingDetails || isUpdatingBillingDetails || !billingDetails}>
            {() => (
                <Form
                    actionContainerSubmit
                    initialValues={billingDetails ? getDefaultFormValue(billingDetails) : emptyBillingDetails}
                    onSubmit={(values) => {
                        const request = formValueToCreateClientRecordInvitationRequest(values);
                        updateBillingDetails(request);
                    }}
                    onCancel={onCancel}
                    isDisabled={isLoadingBillingDetails || isUpdatingBillingDetails}
                >
                    {() => {
                        return <EditClientBillingInfoFields />;
                    }}
                </Form>
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(EditClientRecordBillingContactDetails);
